import { STORE_ID } from '@/js/api/const.ts';
import { makeRequest } from '@/js/api/request-service.ts';

export async function addCompare(productId: number) {
  return makeRequest({
    method: 'GET',
    url: `/api/${STORE_ID}/compare/product/${productId}/push`,
  });
}

export async function removeCompare(productId: number) {
  return makeRequest({
    method: 'GET',
    url: `/api/${STORE_ID}/compare/product/${productId}/remove`,
  });
}
